import { Encoder } from './Encoder';
import { Messages } from './Message';
import { ProjectUsers } from './ProjectUser';
import { Stream } from './Stream';
import { User } from './User';

export type Project = {
  id: string;
  streamId: string;
  createdByUser?: User;
  created: string;
  createdUtc: string;
  updated: string;
  updatedUtc: string;
  deleted: string;
  deletedUtc: string;
  broadcastStartedUtc: string;
  broadcastStarted: string;
  broadcastEndedUtc: string;
  broadcastEnded: string;
  name: string;
  scheduledDateTime: string;
  scheduledTime: string;
  scheduledDateTimeUtc: string;
  scheduledTimeZone: string;
  scheduledDuration: number;
  duration: number;
  streamTextEventName: string;
  projectUserId: string;
  projectUserName: string;
  projectUsers: ProjectUsers;
  messages: Messages;
  stream: Stream;
  encoder: Encoder;
  paymentStatus: string;
};

export type ProjectContext = {
  project: Project;
  setProject: (data: Project) => void;
  updateEncoder: (encoder: Encoder, properties: Record<string, string | number | boolean>, debounce?: number | undefined) => void;
  updateStream: (properties: Record<string, string | number | boolean>, debounce?: number | undefined) => void;
  isAwaitingApiSaveToComplete: boolean;
};

export const DefaultProject: Project = {
  id: '',
  streamId: '',
  created: '',
  createdUtc: '',
  updated: '',
  updatedUtc: '',
  deleted: '',
  deletedUtc: '',
  broadcastStartedUtc: '',
  broadcastStarted: '',
  broadcastEndedUtc: '',
  broadcastEnded: '',
  name: '',
  scheduledDateTime: '',
  scheduledTime: '',
  scheduledDateTimeUtc: '',
  scheduledTimeZone: '',
  scheduledDuration: 0,
  duration: 0,
  streamTextEventName: '',
  projectUserId: '',
  projectUserName: '',
  stream: {} as Stream,
  encoder: {} as Encoder,
  messages: [],
  projectUsers: [],
  paymentStatus: ''
};
